<template>
  <section class="jsk-block">
    <div class="container">
      <div class="row text-center">
        <div class="col-12">
          <h2>{{ $t("privateSchoolsPage.benefitsTitle") }}</h2>
        </div>
      </div>

      <div class="row mt-5">
        <!-- benefit 1 -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-1.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("privateSchoolsPage.benefitsTitles[0]") }}</p>
                <p class="mt-3">{{ $t("privateSchoolsPage.benefitsDescr[0]") }}</p>
             </div>
          </div>
        </div>
        
       <!-- benefit 2 -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-2.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("privateSchoolsPage.benefitsTitles[1]") }}</p>
                <p class="mt-3">{{ $t("privateSchoolsPage.benefitsDescr[1]") }}</p>
             </div>
          </div>
        </div>
      </div>  

    <div class="row mt-lg-5 mt-0">
       <!-- benefit 3 -->
       <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-3.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("privateSchoolsPage.benefitsTitles[2]") }}</p>
                <p class="mt-3">{{ $t("privateSchoolsPage.benefitsDescr[2]") }}</p>
             </div>
          </div>
        </div>

        <!-- benefit 4s -->
        <div class="col-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-2">
              <img src="./../assets/images/blocks/block-4.png" class="w-75 img-fluid">  
            </div>
             <div class="col-10">
                <p class="h4 mt-0">{{ $t("privateSchoolsPage.benefitsTitles[3]") }}</p>
                <p class="mt-3">{{ $t("privateSchoolsPage.benefitsDescr[3]") }}</p>
             </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "benefitsSchools"
};
</script>